import { IActivityHistoryItem } from "../model";
import { Spec } from "./spec";

export class RelevantSpec extends Spec<IActivityHistoryItem> {
  constructor(public context: IActivityHistoryItem) {
    super();
  }
  isSatisfiedBy(context: IActivityHistoryItem): boolean {
    return context?.relevant ?? false;
  }
}
